<template>
    <div class="container_table_main_table main_table"
        :style="maxHeight ? { maxHeight: maxHeight + 'px' } : null">
        <table class="big_table">
            <!-- Anchos por modo/categorías (colWidths). En el Libro Mayor (readOnly)
                 se quita la columna Clasificación y se agrega la del gráfico; los
                 anchos se recalculan para ocupar el 100%. -->
            <colgroup>
                <col v-for="(width, iCol) in colWidths" v-bind:key="iCol"
                    :style="{ width: width + '%' }" />
            </colgroup>
            <tr v-if="accountFilters.length > 0"
                :class="['fix-position', { 'first': accountFilters.length > 0 }]">
                <td colspan="9">
                    <div class="header_filters pl-5">
                        <span v-for="(accountFilter, iAccountFilter) in accountFilters"
                            v-bind:key="iAccountFilter">
                            <span class="itemFilter mr-3"
                                @click="() => $emit('delete-filter', 'accounts', accountFilter)"
                                v-if="accountFilter && iAccountFilter < 4">
                                {{ accountFilter }}
                                <Ecs class="ecsFilter" />
                            </span>
                        </span>
                        <span v-if="accountFilters.length > 4" class="itemFilter">
                            +{{ accountFilters.length - 4 }}
                        </span>
                        <div class="is-pulled-right mr-4">
                            <button class="itemFilter" @click="() => $emit('clear-filter', 'accounts')">
                                Limpiar Filtro
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-if="categoriesFilter.length > 0"
                :class="['fix-position', {
                    'second': categoriesFilter.length > 0 && accountFilters.length > 0,
                    'first': categoriesFilter.length > 0 && accountFilters.length == 0
                }]">
                <td colspan="9">
                    <div class="header_filters pl-5">
                        <span v-for="(categoryFilter, iCategoryFilter) in categoriesFilter"
                            v-bind:key="iCategoryFilter">
                            <span class="itemFilter mr-3"
                                @click="() => $emit('delete-filter', 'category', categoryFilter)"
                                v-if="categoryFilter && iCategoryFilter < 4">
                                {{ categoryFilter }}
                                <Ecs class="ecsFilter" />
                            </span>
                        </span>
                        <span v-if="categoriesFilter.length > 4" class="itemFilter">
                            +{{ categoriesFilter.length - 4 }}
                        </span>
                        <div class="is-pulled-right mr-4">
                            <button class="itemFilter" @click="() => $emit('clear-filter', 'category')">
                                Limpiar Filtro
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
            <tr
                :class="['fix-position', {
                    'third': accountFilters.length > 0 && categoriesFilter.length > 0,
                    'second': accountFilters.length > 0 || categoriesFilter.length > 0,
                    'first': accountFilters.length == 0 && categoriesFilter.length == 0
                }]">
                <td class="ttitle">
                    <div class="tttitle t_razon_social">
                        Nombre
                        <SortButton @click="$emit('sort', 'alias')" class="ml-1"
                            :globalSortColumn="sortColumn" :column="'alias'" :sortDirection="sortDirection">
                        </SortButton>
                    </div>
                </td>
                <td v-if="!readOnly" class="t_clasificacion ttitle">
                    <div class="tttitle td_clasificacion">
                        Clasificación
                        <SortButton @click="$emit('sort', 'classify_by_counterpart')"
                            :globalSortColumn="sortColumn" :column="'classify_by_counterpart'"
                            :sortDirection="sortDirection"></SortButton>
                    </div>
                </td>
                <td class="t_monto ttitle">
                    <div class="tttitle">
                        <span class="nobreak">$ Monto</span>
                        <SortButton @click="$emit('sort', 'total_3_months')"
                            :globalSortColumn="sortColumn" :column="'total_3_months'"
                            :sortDirection="sortDirection"></SortButton>
                    </div>
                </td>
                <td v-if="!hideCounterpartColumn" class="t_contraparte ttitle">
                    <div class="tttitle">
                        Contraparte
                        <SortButton @click="$emit('sort', 'counterpart_type')"
                            :globalSortColumn="sortColumn" :column="'counterpart_type'"
                            :sortDirection="sortDirection"></SortButton>
                    </div>
                </td>
                <td class="t_cuenta_madre ttitle">
                    <div class="tttitle">
                        Cuenta Madre
                        <SortButton @click="$emit('sort', 'mother_accounts')"
                            :globalSortColumn="sortColumn" :column="'mother_accounts'"
                            :sortDirection="sortDirection"></SortButton>
                    </div>
                </td>
                <td v-if="showBalanceConcept" class="t_cuenta_x ttitle">
                    <div class="tttitle">
                        Cuenta X
                        <SortButton @click="$emit('sort', 'balance_concepts')"
                            :globalSortColumn="sortColumn" :column="'balance_concepts'"
                            :sortDirection="sortDirection"></SortButton>
                    </div>
                </td>
                <td class="t_cuenta ttitle">
                    <div class="tttitle">
                        Cuenta
                        <SortButton @click="$emit('sort', 'accounts')" :globalSortColumn="sortColumn"
                            :column="'accounts'" :sortDirection="sortDirection">
                        </SortButton>
                    </div>
                </td>
                <td class="t_categoria ttitle" v-for="type in categories" v-bind:key="type">
                    <div class="tttitle is-capitalized">
                        {{ type }}
                        <SortButton @click="$emit('sort', 'attribute', type)"
                            :globalSortColumn="sortColumn" :column="'attribute_' + type"
                            :sortDirection="sortDirection" />
                    </div>
                </td>
                <td v-if="!readOnly || showReportLink">
                    <!-- editar (clasificador) / gráfico (mayor) -->
                </td>
            </tr>
            <tr v-if="siiSyncing" class="robot_state_row">
                <td colspan="20" class="robot_state_cell">
                    <div class="robot_state">
                        <div class="robot_waves">
                            <span class="robot_wave"></span>
                            <span class="robot_wave"></span>
                            <span class="robot_wave"></span>
                            <span class="robot_badge">
                                <RobotFace class="robot_face" />
                            </span>
                        </div>
                        <p class="robot_title">El robot está obteniendo tus datos del SII</p>
                        <p class="robot_subtitle">Esto puede tardar unos minutos...</p>
                    </div>
                </td>
            </tr>
            <tr v-for="entry in entries" v-bind:key="entry.ci_id + ' ' + entry.counterpart_type"
                class="counterpart_row">
                <td class="fila">
                    <div class="alias is-clickable zhigh" @click="() => $emit('open', entry)">
                        <div class="c_alias">{{ entry.alias }}</div>
                        <!-- En el Libro Mayor (read-only) el RUT es siempre el
                             placeholder (mismo para todos): no se muestra.
                             Ídem recibos y notas de venta (66666666-6). -->
                        <div v-if="!readOnly && !hasPlaceholderRut(entry.counterpart_type)" class="c_rut">
                            {{ entry.rut }}
                        </div>
                    </div>
                </td>
                <td v-if="!readOnly" class="fila">
                    <div class="docs_totals_bar td_clasificacion">
                        <div class="nobreak_classify_desc">
                            <ClassificationPill :value="entry.classify_by_counterpart" />
                        </div>
                        <div class="count_button">
                            <div class="chart_container">
                                <table class="subtable">
                                    <tr>
                                        <td class="progress_td">
                                            <progress :class="getProgressBarClass(entry)"
                                                :value="getProgressValue(entry)"
                                                :max="getProgressMax(entry)" />
                                        </td>
                                        <td class="progress_td">
                                            <div class="docs_totals nobreak">
                                                {{ entry.classified }} /
                                                {{ entry.tax_document_count }}
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </td>
                <td class="fila">
                    <div class="has-text-left">{{ money(entry.total_3_months) }}</div>
                </td>
                <td v-if="!hideCounterpartColumn" class="fila">
                    <CounterpartTypePill :type="entry.counterpart_type" />
                </td>
                <td class="fila">
                    <div class="square_pill pill_sin_clasificar nobreak"
                        v-if="!entry.calculatedAccounts || !entry.calculatedAccounts.length">
                        Sin Clasificar
                    </div>
                    <div class="square_pill pill_mother_account grey_pill nobreak"
                        v-for="(account, index) in entry.calculatedMotherAccounts" v-bind:key="index"
                        v-tooltip.top="labelTooltip(account)">
                        {{ truncateLabel(account) }}
                    </div>
                </td>
                <td v-if="showBalanceConcept" class="fila">
                    <span class="square_pill pill_mother_account grey_pill nobreak"
                        v-for="concept in entry.balance_concepts || []"
                        v-bind:key="concept + '_' + entry.ci_id"
                        v-tooltip.top="labelTooltip(concept)">
                        {{ truncateLabel(concept) }}
                    </span>
                    <span v-if="!entry.balance_concepts || !entry.balance_concepts.length"
                        class="cuenta_x_empty">—</span>
                </td>
                <td class="fila is-capitalized">
                    <div v-if="entry.doc_accounts">
                        <span class="square_pill pill_mother_account grey_pill nobreak"
                            v-for="plan in entry.calculatedAccounts" v-bind:key="plan + entry.ci_id"
                            v-tooltip.top="labelTooltip(plan)">
                            {{ truncateLabel(plan) }}
                        </span>
                    </div>
                    <div v-if="!readOnly && (!entry.accounts || !entry.accounts.length) && entry.doc_accounts.length == 0"
                        class="square_pill pill_clasificar is-clickable" @click="() => $emit('open', entry)">
                        <EditPencil class="edit_pencil" />
                        Clasificar
                    </div>
                </td>
                <td class="fila is-capitalized" v-for="type in categories"
                    v-bind:key="entry.ci_id + '_' + type">
                    <div v-if="type in entry.calculatedCategories">
                        <div v-for="subtype in entry.calculatedCategories[type]"
                            v-bind:key="subtype+'_'+ entry.ci_id"
                            class="pill pill_mother_account blue_pill nobreak">
                            {{ subtype }}
                        </div>
                    </div>
                    <div class="pill pill_sin_clasificar nobreak" v-else>
                        Sin Clasificar
                    </div>
                </td>
                <td v-if="!readOnly" class="fila is-clickable has-text-centered" @click="() => $emit('open', entry)">
                    <EditPencil class="edit_pencil" />
                </td>
                <!-- Libro Mayor: ícono de gráfico → vista más aproximada en el
                     reporte. Sólo si el usuario tiene acceso al reporte. -->
                <td v-if="readOnly && showReportLink" class="fila is-clickable has-text-centered"
                    @click="() => $emit('open-report', entry)"
                    v-tooltip.top="'Ver en el reporte financiero'">
                    <ChartLine class="report_chart_icon" />
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import SortButton from "@/components/modals/SortButton.vue";
import ClassificationPill from "@/components/generics/ClassificationPill.vue";
import CounterpartTypePill from "@/components/generics/CounterpartTypePill.vue";
import EditPencil from "@/components/svg/EditPencil.vue";
import RobotFace from "@/components/svg/RobotFace.vue";
import Ecs from "@/components/svg/Ecs.vue";
import ChartLine from "@/components/svg/ChartLine.vue";
import { parseToMoney } from "@/utils/currency";
import { truncateLabel, labelTooltip } from "@/utils/truncate";
import { hasPlaceholderRut } from "@/utils/counterpartObligation";

export default {
    name: "CounterpartTable",
    components: {
        SortButton,
        ClassificationPill,
        CounterpartTypePill,
        EditPencil,
        RobotFace,
        Ecs,
        ChartLine,
    },
    props: {
        entries: { type: Array, default: () => [] },
        categories: { type: Array, default: () => [] },
        accountFilters: { type: Array, default: () => [] },
        categoriesFilter: { type: Array, default: () => [] },
        sortColumn: { type: String, default: "order" },
        sortDirection: { type: String, default: "asc" },
        siiSyncing: { type: Boolean, default: false },
        // Modo solo lectura (vista Libro Mayor): oculta la columna de editar y el
        // pill "Clasificar". El click en el alias sigue emitiendo `open` — el
        // padre decide qué abrir (un visor read-only en vez del árbol editable).
        readOnly: { type: Boolean, default: false },
        // Sólo en el Libro Mayor (readOnly): muestra la columna con el ícono de
        // gráfico que lleva al reporte financiero. El padre lo pasa según el
        // acceso del usuario (has_financial_report); sin acceso, la columna no
        // se renderiza y los anchos se recalculan para seguir ocupando el 100%.
        showReportLink: { type: Boolean, default: false },
        // Cap de altura (px) medido por el padre desde el viewport: la tabla
        // llena el alto libre y scrollea internamente, sin scroll de página.
        // Null antes de la medición → cae al fallback `max-height` del CSS.
        maxHeight: { type: Number, default: null },
        // Sólo en el Libro Mayor (readOnly) con alcance Balance: oculta la
        // columna Contraparte (las cuentas de balance no tienen contraparte
        // que distinguir) y los anchos se recalculan al 100%.
        hideCounterpartColumn: { type: Boolean, default: false },
        // Sólo en el Libro Mayor (readOnly) con alcance Balance: muestra la
        // columna "Cuenta X" (balance_concept de las cuentas clasificadas)
        // entre Cuenta Madre y Cuenta.
        showBalanceConcept: { type: Boolean, default: false },
    },
    computed: {
        // Anchos de columna (%) en el orden en que se renderizan, según modo y
        // cantidad de categorías. Clasificador: anchos históricos (sin cambios).
        // Libro Mayor (readOnly): sin columna Clasificación, con columna de gráfico
        // al final; suman 100% para ocupar toda la tabla.
        // Orden: Nombre, [Clasificación si !readOnly], Monto, [Contraparte si
        // !hideCounterpartColumn], Cuenta Madre, [Cuenta X si
        // showBalanceConcept], Cuenta, [Categoría×n],
        // [Editar si !readOnly | Gráfico si readOnly].
        colWidths() {
            const n = this.categories.length;
            if (this.readOnly) {
                if (this.hideCounterpartColumn) {
                    // Alcance Balance: sin columna Contraparte; su ancho se
                    // reparte entre Nombre/Cuentas. Con Cuenta X visible, la
                    // columna nueva toma su tajada de las de cuentas.
                    if (this.showBalanceConcept) {
                        if (this.showReportLink) {
                            if (n === 2) return [21, 12, 14, 12, 14, 10, 11, 6];
                            if (n === 1) return [25, 13, 16, 12, 16, 12, 6];
                            return [28, 16, 18, 13, 19, 6];
                        }
                        if (n === 2) return [23, 13, 15, 12, 15, 10, 12];
                        if (n === 1) return [26, 14, 17, 12, 17, 14];
                        return [31, 17, 19, 14, 19];
                    }
                    if (this.showReportLink) {
                        if (n === 2) return [24, 14, 16, 16, 12, 12, 6];
                        if (n === 1) return [28, 15, 19, 19, 13, 6];
                        return [32, 19, 21, 22, 6];
                    }
                    if (n === 2) return [26, 15, 17, 17, 12, 13];
                    if (n === 1) return [29, 16, 20, 20, 15];
                    return [36, 20, 22, 22];
                }
                if (this.showReportLink) {
                    // Con columna de gráfico al final.
                    if (n === 2) return [20, 12, 12, 14, 14, 11, 11, 6];
                    if (n === 1) return [24, 13, 13, 16, 16, 12, 6];
                    return [28, 15, 15, 18, 18, 6];
                }
                // Sin gráfico (sin acceso al reporte): se reparte ese ancho.
                if (n === 2) return [22, 13, 13, 15, 15, 11, 11];
                if (n === 1) return [25, 14, 14, 17, 17, 13];
                return [30, 16, 16, 19, 19];
            }
            if (n === 2) return [20, 10, 10, 10, 10, 10, 10, 10, 2];
            if (n === 1) return [20, 10, 10, 10, 15, 15, 15, 2];
            return [30, 10, 10, 10, 15, 20, 5];
        },
    },
    methods: {
        truncateLabel,
        labelTooltip,
        hasPlaceholderRut,
        money(value) {
            if (value != "") {
                return parseToMoney(value);
            }
        },
        getProgressBarClass(entry) {
            return entry.classified === entry.tax_document_count
                ? "progress_bar_full"
                : entry.classified === 0 ? "progress_bar_empty" : "progress_bar";
        },
        getProgressValue(entry) {
            if (entry.classified === entry.tax_document_count) {
                return entry.classified;
            }
            const classified = 100 * entry.classified;
            return classified + (6 * classified) / (classified + 1.01);
        },
        getProgressMax(entry) {
            return entry.classified === entry.tax_document_count
                ? entry.tax_document_count
                : 100 * entry.tax_document_count;
        },
    },
};
</script>

<style lang="scss" scoped>
// .ecsFilter es compartida con la barra de filtros (CalendarMinus) en el padre;
// se duplica acá porque los estilos scoped no cruzan el límite del componente.
.ecsFilter {
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
    margin-bottom: -5px;
}

.container_table_main_table {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eaecf0;
    overflow-y: auto;
    max-height: 70vh;
    scrollbar-width: none;
}

.main_table {
    border-collapse: collapse;
}

.big_table {
    width: 100%;
    table-layout: fixed;
    max-width: 100%;
    border-radius: 8px;
}

.fix-position {
    position: sticky;
    z-index: 1;
    background-color: white;
}

.first {
    top: 0px;
}

.second {
    top: 30px;
}

.third {
    top: 60px;
}

.header_filters {
    background-color: #eaecf0;
    height: 30px;
}

.itemFilter {
    padding: 2px 4px 2px 8px;
    align-items: center;
    gap: 2px;
    border-radius: 6px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--Base-White, #FFF);

    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    color: var(--Gray-700, #344054);
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
}

.ttitle {
    text-align: center;
    vertical-align: middle;
    padding: 10px 0 10px 0;
}

.td_clasificacion {
    max-width: 100px !important;
}

.tttitle {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fcfcfd;
    box-sizing: border-box;
    text-align: left;
    font-size: 12px;
    color: #475467;
    font-family: Inter;
}

.t_razon_social {
    margin-left: 7px;
}

.t_clasificacion {
    padding: 10px 0 10px 0;
}

.t_contraparte {
    padding: 10px 0 10px;
}

.counterpart_row {
    border-top: 1px solid #eaecf0;
    margin-bottom: 10px;
}

.alias {
    margin: 16px 8px;
    text-align: left;
}

.fila {
    background-color: #ffffff;
    vertical-align: middle;
}

.c_alias {
    line-height: 20px;
    text-transform: uppercase;
    font-weight: 400;
    line-height: 20px;
    color: #101828;
}

.c_rut {
    font-size: 80%;
    font-weight: 500;
    line-height: 20px;
    color: #465467;
}

.nobreak_classify_desc {
    text-align: left;
    white-space: nowrap;
    font-size: 80%;
}

.count_button {
    text-align: center;
}

.chart_container {
    display: flex;
    align-items: center;
}

.pill_sin_clasificar {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.blue_pill {
    background-color: #f4f3ff;
    border: 1px solid #d9d6fe;
}

.grey_pill {
    background-color: #eaecf0;
    border: 1px solid #d0d5dd;
}

// "Sin Cuenta X" (alcance Balance): guion muted, no un pill — la ausencia no
// es un estado a corregir como "Sin Clasificar".
.cuenta_x_empty {
    color: #98a2b3;
}

.pill_mother_account {
    line-break: auto;
    display: block;
    color: #475467;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.square_pill {
    position: relative;
    border-radius: 4px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px 2px 1px 2px;
    text-align: center;
    font-size: 12px;
    font-family: Inter, "Open Sans", sans-serif;
    width: min-content;
    min-width: 4em;
}

.pill {
    position: relative;
    border-radius: 16px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px 8px 1px 8px;
    text-align: center;
    font-size: 12px;
    font-family: Inter, "Open Sans", sans-serif;
    width: min-content;
    overflow-wrap: break-word;
    word-wrap: break-word;
    min-width: 4em;
}

.edit_pencil {
    margin-right: 2px;
}

.report_chart_icon {
    width: 20px;
    height: 20px;
    opacity: 0.65;
    transition: opacity 0.15s ease;
}

.report_chart_icon:hover {
    opacity: 1;
}

.pill_clasificar {
    position: relative;
    box-shadow: 0px 1px 8px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fef3f2;
    border: 1px solid #fecdca;
    box-sizing: border-box;
    width: 103px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    gap: 4px;
    text-align: left;
    font-size: 12px;
    color: #b42318;
    font-family: Inter;
    font-weight: 600;
}

progress {
    appearance: none;
}

$progress_background: #d0d5dd;
$progress_bar_normal: #00a9be;
$progress_bar_full: #00a9be;
$progress_bar_empty: #f63c3c;

.progress_bar {
    background-color: $progress_background;
    border-radius: 13px;
    border: 0;
    height: 10px;
    width: 50px;
}

.progress_bar::-webkit-progress-bar {
    background-color: $progress_background;
    border-radius: 13px;
}

.progress_bar::-webkit-progress-value {
    background-color: $progress_bar_normal;
    border-top-left-radius: 13px;
    border-bottom-left-radius: 13px;
}

.progress_bar::-moz-progress-bar {
    background-color: $progress_bar_normal;
}

.progress_bar_empty {
    background-color: $progress_bar_empty;
    border-radius: 13px;
    border: 0;
    height: 10px;
    width: 50px;
}

.progress_bar_full {
    background-color: $progress_background;
    border-radius: 13px;
    border: 0;
    height: 10px;
    width: 50px;
}

.progress_bar_full::-webkit-progress-bar {
    background-color: $progress_background;
    border-radius: 13px;
}

.progress_bar_full::-webkit-progress-value {
    background-color: $progress_bar_full;
    border-radius: 13px;
}

.progress_bar_full::-moz-progress-bar {
    background-color: $progress_bar_full;
}

.progress_td {
    vertical-align: middle;
    width: 50%;
}

.docs_totals {
    position: relative;
    top: 3px;
    margin-left: 20px;
    font-size: 10px;
    line-height: 20px;
    font-weight: 500;
    font-family: Inter;
    color: #344054;
    text-align: left;
}

.docs_totals_bar {
    padding: 5px 0 0 0;
    width: 100px;
}

.zhigh {
    z-index: 3000;
}

// Estado "robot SII trayendo datos": ocupa el cuerpo vacío de la tabla.
.robot_state_cell {
    padding: 0;
    border: none;
}

.robot_state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 56px 16px 72px;
    text-align: center;
}

.robot_waves {
    position: relative;
    width: 260px;
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

// Ondas concéntricas que emanan del robot.
.robot_wave {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 64px;
    height: 64px;
    border: 1px solid var(--accent);
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0.45);
    opacity: 0;
    animation: robot-ripple 3s ease-out infinite;

    &:nth-child(2) {
        animation-delay: 1s;
    }

    &:nth-child(3) {
        animation-delay: 2s;
    }
}

@keyframes robot-ripple {
    0% {
        transform: translate(-50%, -50%) scale(0.45);
        opacity: 0.45;
    }

    100% {
        transform: translate(-50%, -50%) scale(4);
        opacity: 0;
    }
}

.robot_badge {
    position: relative;
    z-index: 1;
    width: 56px;
    height: 56px;
    border-radius: 14px;
    background: var(--paper);
    border: 1px solid var(--rule);
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08);
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.robot_face {
    width: 26px;
    height: 26px;
    color: var(--accent);
}

.robot_title {
    color: var(--ink);
    font-weight: 700;
    font-size: 16px;
    margin-top: 4px;
}

.robot_subtitle {
    color: var(--ink-muted);
    font-size: 14px;
    margin-top: 4px;
}

@media (prefers-reduced-motion: reduce) {
    .robot_wave {
        animation: none;
        opacity: 0.25;
    }
}
</style>
